import { render, staticRenderFns } from "./EscovacaoSupervisionada.vue?vue&type=template&id=fc1cf4d0"
import script from "./EscovacaoSupervisionada.vue?vue&type=script&lang=js"
export * from "./EscovacaoSupervisionada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports